import React from 'react';

import { LazyImage } from '@tecma/ds';

import logo from 'assets/images/logo-tecma.svg';

import './footer.scss';

const Footer: React.FC = () => {
  return (
    <div className='footer'>
      <LazyImage.Image src={logo} />
      <span className='copyright'>© 2025 TECMA Business Technology Platform</span>
    </div>
  );
};

export default React.memo(Footer);
